import type { ExternalTableSchema } from '@packages/table-builder';
import {
  releaseItemFilters,
  releaseItemSearchRequestParams,
  releaseSelectedItemColumns,
  withReleaseIdEndpoint,
} from '@apps/customer/pages/release/shared/releaseItemTableShared';

export { withReleaseIdEndpoint };

export const releaseSelectedItemsTable: ExternalTableSchema = {
  metadata: {
    title: 'Select items for Release',
    entity: 'ReleaseSelectedItems',
  },
  dataSource: {
    endpoint: '/api/award/api/app/release/vesting-list',
    method: 'GET',
    rowIdField: 'id',
    fetchPolicy: 'requireFilter',
    requestParams: { ...releaseItemSearchRequestParams },
    filters: releaseItemFilters,
  },
  columns: releaseSelectedItemColumns,
  actions: {
    bulk: [{ id: 'ADD_TO_RELEASE_SELECTED', label: 'Add to Release' }],
  },
  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: { keyField: 'id', selectAllPages: true },
  },
};
